import React from "react";
import "./style.scss";

export default function Detail({ detail = {}, convertDateTime }) {
  const {
    National,
    CitizenIDNo,
    CitizenExpiredDateFirstTime,
    IDNo,
    HometownAddress,
    BirthCity,
    BirthDistrict,
    BirthWard,
    BirthAddress,
    NativeCity,
    NativeDistrict,
    NativeWard,
    CitizenIDIssueDate,
    HometownDistrict,
    NativeAddress,
    TemporaryCity,
    TemporaryDistrict,
    HometownWard,
    TemporaryWard,
    PhoneNumber,
    TemporaryAddress,
    CitizenExpiredDateThirdTime,
    MaritalStatus,
    Ethnic,
    Religion,
    PassportNo,
    PassportEffectDate,
    Email,
    PassportExpireDate,
    CitizenExpiredDateSecondTime,
  } = detail;
  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">National</div>
            <div className="form-value">
              <span>{National}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Citizen ID No</div>
            <div className="form-value">
              <span>{CitizenIDNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Citizen Expired Date 1st</div>
            <div className="form-value">
              <span>
                {convertDateTime(convertDateTime(CitizenExpiredDateFirstTime))}
              </span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">ID No</div>
            <div className="form-value">
              <span>{IDNo}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Home Town</div>
            <div className="form-value">
              <span>{HometownAddress}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Email</div>
            <div className="form-value">
              <span>{Email}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Citizen ID Issue Date</div>
            <div className="form-value">
              <span>
                {convertDateTime(convertDateTime(CitizenExpiredDateFirstTime))}
              </span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Citizen Expired Date 2nd</div>
            <div className="form-value">
              <span>
                {convertDateTime(convertDateTime(CitizenExpiredDateSecondTime))}
              </span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">ID Issue Date</div>
            <div className="form-value">
              <span>
                {convertDateTime(convertDateTime(CitizenIDIssueDate))}
              </span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Hometown District</div>
            <div className="form-value">
              <span>{HometownDistrict?.DistrictName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Phone Number</div>
            <div className="form-value">
              <span>{PhoneNumber}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Citizen ID Issue Place</div>
            <div className="form-value">
              <span>Chưa có trong DB</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Citizen Expired Date 3rd</div>
            <div className="form-value">
              <span>{convertDateTime(CitizenExpiredDateThirdTime)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">ID Issue Place</div>
            <div className="form-value">
              <span>Chưa có trong DB</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Hometown Ward</div>
            <div className="form-value">
              <span>{HometownWard?.WardName}</span>
            </div>
          </div>
        </div>
      </div>
      <h4 className="fs-12 fw-bold ml-2 mr-2 mb-0">
        House number, hamlet of the hometown
      </h4>
      <div className="form-readonly ml-2 mr-2 mt-1">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Hometown Address</div>
            <div className="form-value">
              <span>{HometownAddress}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Birth City</div>
            <div className="form-value">
              <span>{BirthCity}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Birth District</div>
            <div className="form-value">
              <span>{BirthDistrict}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Birth Ward</div>
            <div className="form-value">
              <span>{BirthWard}</span>
            </div>
          </div>
        </div>
      </div>
      <h4 className="fs-12 fw-bold ml-2 mr-2 mt-0 mb-0">
        House number, hamlet of birth
      </h4>
      <div className="form-readonly ml-2 mr-2 mt-1">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Birth Address</div>
            <div className="form-value">
              <span>{BirthAddress}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Native City</div>
            <div className="form-value">
              <span>{NativeCity}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Native District</div>
            <div className="form-value">
              <span>{NativeDistrict}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Native Ward</div>
            <div className="form-value">
              <span>{NativeWard}</span>
            </div>
          </div>
        </div>
      </div>
      <h4 className="fs-12 fw-bold ml-2 mr-2 mt-0 mb-0">
        House number, hamlet of native
      </h4>
      <div className="form-readonly ml-2 mr-2 mt-1">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Native Address</div>
            <div className="form-value">
              <span>{NativeAddress}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Temporary City</div>
            <div className="form-value">
              <span>{TemporaryCity}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Temporary District</div>
            <div className="form-value">
              <span>{TemporaryDistrict}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Temporary Ward</div>
            <div className="form-value">
              <span>{TemporaryWard}</span>
            </div>
          </div>
        </div>
      </div>
      <h4 className="fs-12 fw-bold ml-2 mr-2 mt-0 mb-0">
        House number, hamlet of temporary
      </h4>
      <div className="form-readonly ml-2 mr-2 mt-1">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Temporary Address</div>
            <div className="form-value">
              <span>{TemporaryAddress}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Passport No</div>
            <div className="form-value">
              <span>{PassportNo}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Marital Status</div>
            <div className="form-value">
              <span>{MaritalStatus}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Passport Effect Date</div>
            <div className="form-value">
              <span>{convertDateTime(PassportEffectDate)}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Ethnic</div>
            <div className="form-value">{Ethnic}</div>
          </div>
          <div className="form-group">
            <div className="form-label">Passport Expire Date</div>
            <div className="form-value">
              {convertDateTime(PassportExpireDate)}
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Religion</div>
            <div className="form-value">
              <span>{Religion}</span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
